import { apiGeneric, apiConfiguration as http } from '../../../http';
//
class ConfigurationService {
  getAllConfigs() {
    return http.get('/configurations');
  }

  updateConfigs(configurations) {
    return http.put(`/configurations/${configurations._id}`, configurations);
  }

  updateLogo(data) {
    return http.post(`/img/upload/logo`, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
  }

  updateLogoSocial(data) {
    return http.post(`/img/upload/logosocial`, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
  }

  updateLogoChat(data) {
    return http.post(`/img/upload/logochat`, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
  }

  updateLogoFlexia(data) {
    return http.post(`/img/upload/logoflexia`, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    });
  }

  getAIConfig() {
    return apiGeneric.get(
      `flex-chat-integration/api/configurations/chatgptconfig`
    );
  }

  getAIConfigSearch = (size = 10, page = 1, nameChannel = '') => {
    return apiGeneric.get(
      `flex-chat-integration/api/configurations/chatgptconfig`,
      {
        headers: {
          limit: size,
          offset: size * (page - 1)
        },
        params: {
          nameChannel,
          limit: size,
          offset: size * (page - 1)
        }
      }
    );
  };

  getAIConfigById(id) {
    return apiGeneric.get(
      `flex-chat-integration/api/configurations/chatgptconfig/${id}`
    );
  }
  postAIConfig(data) {
    return apiGeneric.post(
      `flex-chat-integration/api/configurations/chatgptconfig`,
      data
    );
  }
  putAIConfig(data, id) {
    return apiGeneric.put(
      `flex-chat-integration/api/configurations/chatgptconfig/${id}`,
      data
    );
  }
  deleteAIConfig(id) {
    return apiGeneric.delete(
      `flex-chat-integration/api/configurations/chatgptconfig/${id}`
    );
  }
}

export default new ConfigurationService();
